namespace TabAurous.Stock {
    export namespace JobTransactionService {
        export const baseUrl = 'Stock/JobTransaction';

        export declare function Create(request: Serenity.SaveRequest<JobTransactionRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<JobTransactionRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<JobTransactionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<JobTransactionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<JobTransactionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomJobTransactionList(request: ProductRequest, onSuccess?: (response: Serenity.RetrieveResponse<JobTransactionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomJobReceiptValues(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<JobTransactionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetPartyMetalBalance(request: TransactionRequest, onSuccess?: (response: Serenity.RetrieveResponse<JobTransactionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Stock/JobTransaction/Create",
            Update = "Stock/JobTransaction/Update",
            Delete = "Stock/JobTransaction/Delete",
            Retrieve = "Stock/JobTransaction/Retrieve",
            List = "Stock/JobTransaction/List",
            CustomList = "Stock/JobTransaction/CustomList",
            CustomJobTransactionList = "Stock/JobTransaction/CustomJobTransactionList",
            CustomJobReceiptValues = "Stock/JobTransaction/CustomJobReceiptValues",
            GetPartyMetalBalance = "Stock/JobTransaction/GetPartyMetalBalance"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList', 
            'CustomJobTransactionList', 
            'CustomJobReceiptValues', 
            'GetPartyMetalBalance'
        ].forEach(x => {
            (<any>JobTransactionService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
